import React from "react";

interface PlateNumberPanelProps {
  plateNumber: string;
}

const PlateNumberPanel: React.FC<PlateNumberPanelProps> = ({ plateNumber }) => {
  return (
    <article className="flex rounded-xl border border-foreground overflow-hidden">
      <div className="w-8 bg-primary border-r border-foreground" />
      <div className="bg-card text-card-foreground text-[3rem] leading-8 py-4 px-8 font-bold">{plateNumber}</div>
    </article>
  );
};

export default PlateNumberPanel;
